<template>
  <div class="x-maincompany">
    <el-tabs v-model="activeName" @tab-click="" v-loading="allmainproloading">
      <el-tab-pane label="资讯中心" name="first">
        <div class="x-go-addnews">
          <router-link to="/index/addnews" class="x-btn x-btn-bl x-class-ad">
            <span class="x-ac-addbtn"></span>添加资讯
          </router-link>
        </div>

        <el-table :data="misslist" style="width: 100%" >
          <el-table-column label="" width="">
            <template slot-scope="scope">
              <div  class="x-com-ll">
                <img :src="scope.row.cover" alt="" width="70px" height="70px" style="display:inline-block">
                <span style="margin-left: 10px">{{ scope.row.title }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="" width="">
            <template slot-scope="scope">
              <span class="x-ac-modyfy" @click="modifyclalist(scope.row,'1')">修改</span>
              <span class="x-ac-remove" @click.stop="removeclalist(scope.row.id,scope.row.title)">删除</span>
            </template>
          </el-table-column>
        </el-table>
        <!-- <el-pagination
          @current-change="handleCurrentChangetwo"
          :current-page="currentPage"
          :page-size="pagesize"
          layout="total, prev, pager, next, jumper"
          :total="misslist.length"
          background
          class="x-pagination">
        </el-pagination> -->
      </el-tab-pane>
      <el-tab-pane label="网盘" name="second">
        <div class="x-miss-addbox"><el-button type="primary" @click="opentoast"><span class="x-ac-addbtn"></span>上传文件</el-button></div>

        <el-tabs v-model="activeName2" type="card" @tab-click="handleClick">
          <el-tab-pane :label="item.title" :name="index.toString()" v-for="(item,index) in pantabsdata" :key="item.id" :value="item.id">
            <ul class="x-main-ul">
              <div class="" v-if="classlistli.length != 0">
                <li v-for="(item,index) in classlistli" :key="item.key">
                  <!-- <img class="x-main-img" :src='item.img' size="small" v-if="item.img!=''"></img> -->
                  <img class="x-main-img" src='../images/file.png' size="small"></img>
                  <div class="x-main-text">{{item.filename}}</div>
                  <div class="x-main-btngroup">
                    <span class="x-btn x-main-btn2" @click="editclassli(item.id,item.file_name)">删除</span>
                  </div>
                </li>
            </div>
            <div class="x-noclass-desc" v-else>
              还没有文件哦
            </div>
            </ul>
          </el-tab-pane>
        </el-tabs>


        <!-- <el-pagination
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-size="pagesize"
          layout="total, prev, pager, next, jumper"
          :total="classlistli.length"
          background
          class="x-pagination">
        </el-pagination> -->
      </el-tab-pane>
    </el-tabs>
    <!-- <div class="x-main-searchbox">
      <el-input v-model="searchuser" placeholder="输入关键字" class="x-search-input" clearable></el-input>
      <span class="x-btn"><span class="x-search-icon"></span>搜索</span>
    </div> -->
    <!--添加文件-->
		<el-dialog title="新增文件" :visible.sync="addmisstoast" :close-on-click-modal='noshowmodal'>
      <div class="x-addclass-box">
      	<el-form :model="newfiledata" ref="newfiledata" label-width="100px" class="demo-ruleForm">
          <el-form-item label="上传文件：">
            <div class="x-ma-up">
              <el-input
                placeholder=""
                v-model="newfiledata.showname"
                :disabled="true">
              </el-input>
              <el-upload
                  class="upload-demo"
                  action="http://peixun.dlbbdk.com/upload/oss"
                  multiple
                  :limit="1"
                  :on-success="examfilefun"
                  accept=".xls,xlsx,.doc,.ppt,.pdf,.txt,.docx,.jpg,.gif,.png,.jpeg,.mp3,.mp4"
                  :on-exceed="nomore"
                  :show-file-list='false'
                  :file-list="fileListTest">
                  <el-button size="small" type="primary">点击上传</el-button>
              </el-upload>
            </div>
          </el-form-item>
          <el-form-item label="选择分类">
            <el-select v-model="choosepan" placeholder="请选择" @change="selectpan">
              <el-option :label="item.title" :value="item.id" v-for="item in pantabsdata" :key="item.title"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
			<div slot="footer" class="dialog-footer">
				<el-button type="primary" @click="addfileok">确认</el-button>
			</div>
		</el-dialog>
  </div>
</template>

<script>
import axios from 'axios';
export default {
  name: 'maincompany',
  data () {
    return {
      activeName:'first',
      activeName2:'0',
      addmisstoast:false,
      misslist:[],
      searchuser:'',
      currentPage:1,//默认显示第几页
      pagesize:3,//每页个数
      switchtop:false,
      allmainproloading:true,
      classlistli:'',
      newfiledata:{
        showname:'',
        examfile:''
      },
      fileListTest:[],
      testname:'',//文件名字
      headimg:[],
      showimg1:'',
      showimg2:'',
      showimg3:'',
      value1:true,
      noshowmodal:false,
      typedoc:'',
      pantabsdata:'',
      choosepan:''
    }
  },
  created() {
    this.articleList()//资讯列表
    this.filelist()//文件列表

  },
  methods:{
    //网盘分类下拉框选择
    selectpan:function(val){
      console.log(val);
    },
    // 时间戳转时间
    timechangetime(times){
      var date = new Date((parseInt(timers) + 8 * 3600) * 1000).toJSON().substr(0, 19).replace('T', ' ').replace(/-/g, '-');
      console.log(date);
    },
    // 打开新增文件
    opentoast(){
      this.addmisstoast=true;
      this.newfiledata.showname = '';
      this.fileListTest = []
    },
    // 选项卡
    handleClick(tab, event) {
      console.log(tab.$attrs.value);
      this.filelist(tab.$attrs.value)
    },
    // 分页
    handleCurrentChange(val){
      console.log(`当前页: ${val}`);
    },
    // 分页
    handleCurrentChangetwo(val){
      console.log(`当前页: ${val}`);
    },
    // 资讯列表
    articleList(){
      axios.get('/admin/article/list', {
        params: {
          sec: localStorage.token}
      })
      .then(function (response) {
        console.log(response);
        if(response.data.status == 1){
            this.allmainproloading = false;
            console.log(response.data.data);
            this.misslist = response.data.data;//列表数据
            for(let i=0;i<this.misslist.length;i++){
              this.misslist[i].create_time = new Date((parseInt(this.misslist[i].create_time) + 8 * 3600) * 1000).toJSON().substr(0, 10).replace('T', ' ').replace(/-/g, '-');
            }
            console.log(this.misslist);
        }else{
          this.$message({
            showClose: true,
            message:response.data.msg ,
            type: 'error'
          });
        }
      }.bind(this))
      .catch(function (error) {
        console.log(error);
      });
    },
    // 置顶
    switchchange(istop,id){
      console.log('是否置顶了：'+istop);
      console.log('被置顶的资讯id：'+id);
      console.log(this.switchtop);
      if(istop == 1){
          axios.get('/learn/company/topArticle', {
            params: {
              sec: localStorage.token,
              id:id
            }
          })
          .then(function (response) {
            console.log(response);
            if(response.data.status == 1){
                this.$message('置顶成功');
                this.articleList()//文件列表
            }else{
              this.$message({
                showClose: true,
                message:response.data.msg ,
                type: 'error'
              });
            }
          }.bind(this))
          .catch(function (error) {
            console.log(error);
          });
      }else{
        axios.get('/learn/company/topArticle', {
          params: {
            sec: localStorage.token,
            id:id
          }
        })
        .then(function (response) {
          console.log(response);
          if(response.data.status == 1){
              this.$message('取消置顶成功');
              this.articleList()//文件列表
          }else{
            this.$message({
              showClose: true,
              message:response.data.msg ,
              type: 'error'
            });
          }
        }.bind(this))
        .catch(function (error) {
          console.log(error);
        });
      }
    },
    // 删除资讯
    removeclalist(id,name){
      this.$confirm('确定删除“'+name+'”?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          axios.get('/admin/article/del', {
            params: {
              sec: localStorage.token,
              id:id
            }
          })
          .then(function (response) {
            console.log(response);
            if(response.data.status == 1){
              this.articleList()
              this.$message({
                type: 'success',
                message: '删除成功!'
              });
            }else{
              this.$message({
                showClose: true,
                message:response.data.msg ,
                type: 'error'
              });
            }
          }.bind(this))
          .catch(function (error) {
            console.log(error);
          });


        }).catch(() => {

        });
    },
    // 修改资讯
    modifyclalist(classdata,isedit){
      console.log(classdata);
      console.log(isedit);
      this.$router.push({
        name:'addnews',
        params:{
          classdata:classdata,
          isedit:isedit
        }
      });
    },
    // 上传文件
    examfilefun(res, content){
      console.log('文件名字：'+content.name);
      this.testname = content.name;
      console.log(res);
      if(res.status == 1){
        console.log('文件地址：'+res.data[0].url);
        this.newfiledata.examfile = res.data[0].url;
        this.newfiledata.showname = this.testname
      }else{
        this.$message({
          showClose: true,
          message:res.msg ,
          type: 'error'
        });
      }
    },
    // 上传超过限制
    nomore(){
      this.$message({
        showClose: true,
        message:'不好意思，超过限制啦！' ,
        type: 'error'
      });
    },
    // 确认上传文件
    addfileok(){
      console.log('文件名：'+this.testname);
      console.log('文件地址'+this.newfiledata.examfile);
      var index= this.newfiledata.examfile.lastIndexOf(".");
      var ext = this.newfiledata.examfile.substr(index+1);
      console.log(ext);
      if(ext=='xls'||ext=='xlsx'||ext=='pdf'||ext=='ppt'||ext=='pptx'||ext=='doc'||ext=='docx'||ext=='txt'||ext=='Exceid'){
        this.typedoc = 1;
      }else if(ext=='jpg'||ext=='gif'||ext=='png'||ext=='jpeg'||ext=='mp3'||ext=='mp4'){
        this.typedoc = 2;
      }
      axios.get('/admin/pan/add', {
        params: {
          sec: localStorage.token,
          fileName:this.testname,
          url:this.newfiledata.examfile,
          type:this.choosepan

        }
      })
      .then(function (response) {
        console.log(response);
        if(response.data.status == 1){
            this.$message({
              showClose: true,
              message: '添加文件成功',
              type: 'success'
            });
            this.addmisstoast = false;
            this.filelist()
        }else{
          this.$message({
            showClose: true,
            message:response.data.msg ,
            type: 'error'
          });
        }
      }.bind(this))
      .catch(function (error) {
        console.log(error);
      });
    },
    // 文件列表
    filelist(id){

      axios.get('/admin/pan/list', {
        params: {
          sec: localStorage.token,
          type:id
        }
      })
      .then(function (response) {
        console.log(response);
        if(response.data.status == 1){
            this.allmainproloading = false;
            console.log(response.data.data.list);
            this.classlistli = response.data.data.list;//列表数据
            this.pantabsdata = response.data.data.tab;
            // 获取图片数据源
            for(let i=0;i<response.data.data.list.length;i++){
              let asd = response.data.data.list[i].file_name;
              let fgh = asd.split(".")
              this.headimg.push(fgh[1])
            }
            var aa=this.classlistli;
            for (var i = 0; i < aa.length; i++) {
              if (aa[i].file_name.split('.')[1]=='pptx' || aa[i].file_name.split('.')[1]=='ppt') {
                aa[i].img='https://cqwdnew.oss-cn-qingdao.aliyuncs.com/image/ppt.png'
              }
              if (aa[i].file_name.split(".")[1]=='docx' || aa[i].file_name.split('.')[1]=='doc') {
                aa[i].img='https://cqwdnew.oss-cn-qingdao.aliyuncs.com/image/doc.png'
              }
              if (aa[i].file_name.split(".")[1]=='xls' || aa[i].file_name.split('.')[1]=='xlsx') {
                aa[i].img='https://cqwdnew.oss-cn-qingdao.aliyuncs.com/image/xls.png'
              }
              if (aa[i].file_name.split(".")[1]=='txt') {
                aa[i].img='https://cqwdnew.oss-cn-qingdao.aliyuncs.com/image/txt.png'
              }
              if (aa[i].file_name.split(".")[1]=='pdf') {
                aa[i].img='https://cqwdnew.oss-cn-qingdao.aliyuncs.com/image/pdf.png'
              }
            }
            this.classlistli=aa;
            console.log(this.classlistli);
        }else{
          this.$message({
            showClose: true,
            message:response.data.msg ,
            type: 'error'
          });
        }
      }.bind(this))
      .catch(function (error) {
        console.log(error);
      });
    },
    // 删除文件
    editclassli(id,name){
      this.$confirm('确定删除“'+name+'”?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          axios.get('/admin/pan/del', {
            params: {
              sec: localStorage.token,
              id:id
            }
          })
          .then(function (response) {
            console.log(response);
            if(response.data.status == 1){
              this.filelist()//文件列表
              this.$message({
                type: 'success',
                message: '删除成功!'
              });
            }else{
              this.$message({
                showClose: true,
                message:response.data.msg ,
                type: 'error'
              });
            }
          }.bind(this))
          .catch(function (error) {
            console.log(error);
          });


        }).catch(() => {

        });
    }
  }
}
</script>

<style>
.x-maincompany{
  position: relative;
}
.x-maincompany .el-tabs__nav-wrap::after{
  height: 0;
}.x-maincompany .el-tabs__item.is-active{
  background-color: #BDA17A;
  color: #fff;
  border:1px solid #BDA17A;
}.x-maincompany .el-tabs__active-bar{
  height: 0;
}.x-maincompany .el-tabs__item{
  color: #BDA17A;
  border: 1px solid #BDA17A;
  background-color: #fff;
  width: 100px;
  border-radius: 4px;
  padding: 0;
  margin: 0 15px 0 0;
  text-align: center;
}.x-main-searchbox{
  position: absolute;
  top: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
}.x-btn {
    background-color: #BDA17A;
    font-size: 14px;
    color: #fff;
    text-align: center;
    height: 44px;
    line-height: 44px;
    width: 126px;
    border-radius: 5px;
    cursor: pointer;
    display: inline-block;
    margin-right: 0;
    margin-left: 10px;
    text-decoration: none;
}.x-search-icon {
    background: url(../images/search.png)no-repeat;
    background-size: contain;
    width: 16px;
    margin-right: 8px;
    display: inline-block;
    line-height: 16px;
    height: 16px;
    vertical-align: text-bottom;
}.x-miss-addbox{
  text-align: left;
  margin-bottom: 15px;
}.x-maincompany .el-tabs__header{
  margin: 10px 0 35px 0;
}.x-maincompany .x-ac-modyfy,.x-maincompany .x-ac-remove{
  background: url(../images/change.png)no-repeat;
  background-size: contain;
  width: 14px;
  height: 14px;
  vertical-align: bottom;
  padding-left: 25px;
  margin-right: 20px;
  display: initial;
  color: #BDA17A;
  cursor: pointer;
}.x-maincompany  .x-ac-remove {
    background: url(../images/remove.png)no-repeat;
    background-size: contain;
    color: #FF4D4D;
}.x-ac-addbtn {
    background: url(../images/add.png)no-repeat;
    background-size: contain;
    margin-right: 10px;
    width: 10px;
    height: 10px;
    display: inline-block;
}.x-maincompany .el-table th{
  text-align: center;
}.x-go-addnews{
  text-align: left;
  margin-bottom: 20px;
}.x-maincompany .el-table .cell{
  text-align: center;
}.x-pagination{
  margin-top: 20px;
}.x-maincompany .x-btn{
  margin-left: 0;
}.x-maincompany .x-miss-addbox .el-button.el-button--primary.el-button--small{
  width: 126px;
  height: 44px;
  font-size: 14px;
}.x-noclass-desc{
  color: #ccc;
  font-size: 16px;
  padding-top: 40px;
}.x-main-btn2 {
  background: #fff;
  border: 1px solid #779690;
  color: #779690;
}.x-main-btn2:hover{
  background: #779690;
  border: 1px solid #779690;
  color: #fff;
}
.x-maincompany .x-main-img{
  width: 80px;
  height: 80px;
  position: absolute;
}.x-maincompany .x-main-ul li{
  border-bottom: 1px solid #DDDDDD;
  /* cursor: pointer; */
  position: relative;
  text-align: left;
  margin: 15px 0;
  padding: 15px 0 15px 0;
}.x-main-text {
  padding-left: 100px;
  color: #3F3F3F;
  font-size: 16px;
  line-height: 80px;
  height: 80px;
}.x-main-btngroup {
  position: absolute;
  right: 0;
  top: 50%;
  margin-top: -22px;
}.x-ma-up{
  display: flex;
  align-items: center;
  justify-content: space-between;
}.x-com-ll{
  display: flex;
}.x-com-ll span{
  align-self: center;
}
</style>



// WEBPACK FOOTER //
// src/components/maincompany.vue